import { createContext } from 'react';
import { AlertContextType } from './types';


const defaultContext: AlertContextType = {
    alerts: [],
    show: () => { return; },
    success: () => { return; },
    info: () => { return; },
    error: () => { return; },
}

const AlertContext = createContext<AlertContextType>(defaultContext);

export default AlertContext;
